import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/recharge',
  title: window.language['menu.client.recharge'],
  component: dynamicWrapper(app, [
    import('../../HomePage/model'),
    import('./model'),
    import('../../System/Org/model'), 
    import('../../System/SysConfig/model'),
    import('../../Material/Material/model'), 
    import('../../Material/Folder/model'), 
    import('../../Program/Playlist/model'),
  ], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Client/Recharge/index.js